export default {
  accessToken: '',
  selectedTerm: null,
  selectedId: null,
  college: false,
  foundation: false
}
